import Header from "../../component/Header";
import Layout from "../../component/Layout";
import UsePagination from "../../component/pagination";
import * as S from "./question.styles";
import { useFormik } from "formik";
import * as Yup from "yup";
import provinces from "../../provinces.json";
import SelectComponent from "../../common/textFeilds/SelectComponent";
import "../../component/pagination/pagination.css";
const Question = ({ step, setStep }) => {
  const raceOption = [
    { title: "یک مورد را انتخاب کنید ", value: "" },
    { title: "آذری", value: "azari" },
    { title: "بلوچ", value: "baluch" },
    { title: "بختیاری", value: "bakhtiyari" },
    { title: "تالشی", value: "talesh" },
    { title: "ترکمن", value: "turkaman" },
    { title: "شاهسون", value: "shahsavan" },
    { title: "عرب", value: "arab" },
    { title: "فارس", value: "fars" },
    { title: "قشقایی", value: "ghashghae" },
    { title: "کرد", value: "kurdish" },
    { title: "لک", value: "lak" },
    { title: "گیلک", value: "gilak" },
    { title: "لر", value: "lor" },
    { title: "مازنی", value: "mazani" },
  ];
  const degreeOption = [
    { title: "یک مورد را انتخاب کنید ", value: "" },
    { title: "بیسواد", value: "None" },
    { title: "زیردیپلم", value: "PreDiploma" },
    { title: "دیپلم", value: "Diploma" },
    { title: "فوق دیپلم", value: "PostDiploma" },
    { title: "لیسانس", value: "BSC" },
    { title: "  فوق لیسانس", value: "MSC" },
    { title: "دکترا", value: "PHD" },
  ];

  //1.
  const initialValues = {
    fullname: JSON.parse(localStorage.getItem("infoPerson"))
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].fullname
      : "",
    email: JSON.parse(localStorage.getItem("infoPerson"))
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].email
      : "",
    race: JSON.parse(localStorage.getItem("infoPerson"))
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].race
      : "",
    degree: JSON.parse(localStorage.getItem("infoPerson"))
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].degree
      : "",
    city: JSON.parse(localStorage.getItem("infoPerson"))
      ? JSON.parse(localStorage.getItem("infoPerson"))[step - 1].city
      : "",
  };

  //2.
  const onSubmit = (values) => {
    const datas = [values];
    let info = localStorage.getItem("infoPerson");
    if (info) {
      let parseInfo = JSON.parse(info);
      parseInfo[0] = values;
      localStorage.setItem("infoPerson", JSON.stringify(parseInfo));
    } else {
      localStorage.setItem("infoPerson", JSON.stringify(datas));
    }
    localStorage.setItem("step", JSON.stringify(step));
    setStep(
      parseInt(localStorage.getItem("step"))
        ? parseInt(localStorage.getItem("step")) + 1
        : 1
    );
  };

  //3.
  const validationSchema = Yup.object({
    fullname: Yup.string().required("نام را وارد کنید"),
    email: Yup.string().email("ایمیل را صحیح وارد کنید"),
    race: Yup.string().required("قومیت را وارد کنید"),
    degree: Yup.string().required("سطح تحصیلات را وارد کنید"),
    city: Yup.string().required("استان را وارد کنید"),
  });

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  return (
    <>
      <Header>
        <S.BgHeader style={{ backgroundImage: `url("images/header.png")` }}>
          <S.ContentHeader>
            <S.Title>پرسشنامه پایش سلامت</S.Title>
            <S.Notic>این پرسشنامه از شما کمتر از ۵ دقیقه زمان می‌گیرد.</S.Notic>
          </S.ContentHeader>
        </S.BgHeader>
      </Header>
      <Layout>
        <S.Container>
          <S.InformationTitle>اطلاعات شخصی</S.InformationTitle>
          <form onSubmit={formik.handleSubmit} style={{ marginBottom: "98px" }}>
            <S.FormWrapper>
              <S.InputContainer>
                <S.Lable>
                  نام و نام خانوادگی
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <S.InputField
                  type={"text"}
                  {...formik.getFieldProps("fullname")}
                  name={"fullname"}
                />

                <S.ErrorMessage>
                  {formik.errors["fullname"] && formik.touched["fullname"] && (
                    <div className="error">{formik.errors["fullname"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable> ایمیل</S.Lable>
                <S.InputField
                  style={{ direction: "ltr" }}
                  type={"text"}
                  {...formik.getFieldProps("email")}
                  name={"email"}
                />

                <S.ErrorMessage>
                  {formik.errors["email"] && formik.touched["email"] && (
                    <div className="error">{formik.errors["email"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  قومیت
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <SelectComponent
                  formik={formik}
                  name={`race`}
                  selectOption={raceOption}
                />
                <S.ErrorMessage>
                  {formik.errors["race"] && formik.touched["race"] && (
                    <div className="error">{formik.errors["race"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
              <S.InputContainer>
                <S.Lable>
                  سطح تحصیلات
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <SelectComponent
                  formik={formik}
                  name={`degree`}
                  selectOption={degreeOption}
                />
                <S.ErrorMessage>
                  {formik.errors["degree"] && formik.touched["degree"] && (
                    <div className="error">{formik.errors["degree"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>

              <S.InputContainer>
                <S.Lable>
                  استان محل سکونت
                  <S.Requierd>*</S.Requierd>
                </S.Lable>
                <SelectComponent
                  formik={formik}
                  name={`city`}
                  selectOption={provinces}
                />
                <S.ErrorMessage>
                  {formik.errors["city"] && formik.touched["city"] && (
                    <div className="error">{formik.errors["city"]}</div>
                  )}
                </S.ErrorMessage>
              </S.InputContainer>
            </S.FormWrapper>
            <UsePagination
              step={step}
              // verifySeccess={verifySeccess}
              setStep={setStep}
              formik={formik}
            />
          </form>
        </S.Container>
      </Layout>
    </>
  );
};

export default Question;
